module.exports = __webpack_public_path__ + "static/media/craigslist-purchase_2x.262c147a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/craigslist-purchase_2x.png
// module id = 1172
// module chunks = 27